module.exports = __webpack_public_path__ + "static/media/category18.c80be700.png";